import React from "react"

import { Formik, Form, ErrorMessage } from "formik"
import * as yup from "yup"

import { Fieldset, Modal } from "components"

const mockUser = {
  displayName: "__Test",
  email: "test@test.com",
  password: "Brate13!",
  // phoneNumber: "",
  role: "ADMIN",
}

const userSchema = yup.object().shape({
  displayName: yup.string().required("Full name is reqiured"),
  email: yup
    .string()
    .email("E-mail is not valid!")
    .required("E-mail is required!"),
  password: yup
    .string()
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character",
    ),
  // .required("Password name is reqiured"),
  phoneNumber: yup.string().nullable(),
  role: yup
    .object()
    // .shape({
    //   value: yup.string().required("Role is required"),
    // })
    // .nullable()
    .required("Role is required"),
})

const User = ({ data, isOpen, onClose, onSubmit, onDelete }) => {
  const userModel = {
    displayName: "",
    email: "",
    password: "",
    // phoneNumber: "",
    // role: "",

    ...data,
    ...(data ? { role: { label: data.role, value: data.role } } : {}),

    // ...mockUser,
  }

  const formikProps = {
    initialValues: { ...userModel },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: userSchema,
    onSubmit: async (_values, { setErrors }) => {
      try {
        const { password, phoneNumber, ...values } = _values

        await onSubmit({
          ...values,
          ...(password ? { password } : {}),
          ...(phoneNumber?.trim() ? { phoneNumber } : {}),
          role: values?.role?.value,
          photoURL: values?.photoURL?.url,
        })
        await onClose()
      } catch (error) {
        setErrors({ server: error?.graphQLErrors })
      }
    },
  }

  const ROLES = [
    { label: "ADMIN", value: "ADMIN" },
    { label: "AGENT", value: "AGENT" },
    { label: "LEADER", value: "LEADER" },
    { label: "USER", value: "USER" },
  ]

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      await onDelete(data.id)
      await onClose()
    }
  }

  const isEditing = data ? true : false
  const title = isEditing ? "Edit User" : "Create User"

  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose}>
      <Formik {...formikProps}>
        {({ errors, isSubmitting }) => (
          <Form>
            <div className="px-2 py-3 w-3/12 ">
              <Fieldset
                component="image"
                multiple={false}
                library={false}
                variant="round"
                name="photoURL"
                label="Avatar"
                preload={true}
              />
            </div>

            <div className="py-3">
              <Fieldset label="Full name" type="text" name="displayName" />
            </div>

            <div className="py-3">
              <Fieldset label="Email" type="text" name="email" />
            </div>

            <div className="py-3">
              <Fieldset label="Password" type="text" name="password" />
            </div>

            <div className="py-3">
              <Fieldset label="Phone" type="text" name="phoneNumber" />
            </div>

            <div className="py-3">
              <Fieldset
                component="select"
                label="Role"
                name="role"
                options={ROLES}
              />
            </div>

            <div>
              {data?.id && (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="h-10 px-5 m-2 text-red-100 transition-colors duration-150 bg-red-700 rounded-lg focus:shadow-outline hover:bg-red-800"
                >
                  Delete User
                </button>
              )}
            </div>

            <div className="py-3">
              {errors?.server?.map(({ code, message }) => (
                <div role="alert">
                  <div className="bg-red-500 text-white font-bold rounded-t px-4 py-2">
                    {code}
                  </div>
                  <div className="border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                    <p>{message}</p>
                  </div>
                </div>
              ))}
            </div>

            <ModalNavigation {...{ isSubmitting, onClose }} />
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default User

const ModalNavigation = ({ isSubmitting, onClose }) => {
  return (
    <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <button
          disabled={isSubmitting}
          type="submit"
          className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
        >
          Save
        </button>
      </span>

      <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          onClick={onClose}
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Cancel
        </button>
      </span>
    </div>
  )
}
